module.exports = __webpack_public_path__ + "img/3jpg.8b23d276.jpg";